import {gql} from '@apollo/client';
import client from '@/services/apolloClient';

export const GET_CURRENT_USER_QUERY = gql`
    query GetCurrentUser {
        currentUser {
            uuid
            company {
                uuid
                name
            }
            language
            firstname
            lastname
        }
    }
`;

/**
 * Service pour récupérer les données currentUser via GraphQL
 * Peut être utilisé depuis n'importe où (hooks, fonctions normales, etc.)
 */
export const fetchCurrentUser = async () => {
    const {data, loading, error} = await client.query({
        query: GET_CURRENT_USER_QUERY,
        fetchPolicy: 'network-only'
    });
    return {data: data?.currentUser, error: error};
};
